interface SetCookie {
  name: string;
  value: string;
  days?: number;
  domain?: string;
  path?: string;
}

let defaultDomain = '.check24.de';
if (import.meta.env.DEV) {
  defaultDomain = 'localhost';
}

const setCookie = ({ name = '', value = '', days = 1, domain = defaultDomain, path = '/' }: SetCookie) => {
  if (!name && !value) {
    throw Error('cookie name and/or value not set');
  }

  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${d.toUTCString()}`;

  document.cookie = `${name}=${value};${expires};path=${path};domain=${domain};SameSite=lax`;
};

export default setCookie;
